import clsx from "clsx";
import { OverlayTriggerType } from "react-bootstrap/cjs/OverlayTrigger";
import { Placement } from "react-bootstrap/esm/types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { RenderWhen } from "../../../../components";

interface Props<T> {
  items: T[] | undefined;
  itemMap?: (item: T) => unknown;
  renderKey: string;
  placement?: Placement;
  trigger?: OverlayTriggerType | OverlayTriggerType[];
  tooltipClassName?: string;
  expandDotsClassName?: string;
  className?: string;
}
const ExpandableOverlay = <T,>({
  items,
  itemMap,
  renderKey,
  placement = "right",
  trigger = "click",
  tooltipClassName,
  expandDotsClassName,
  className = "flex align-center"
}: Props<T>) => {
  const [firstItem] = items || [];
  return (
    <div className={className}>
      <span className="overflow-ellipsis">
        {itemMap && firstItem ? itemMap(firstItem) : firstItem ?? "--"}
      </span>
      <RenderWhen condition={Boolean((items?.length ?? 0) > 1)}>
        <OverlayTrigger
          trigger={trigger}
          rootClose
          overlay={
            <Tooltip
              key="expiration-date"
              className={clsx("network-threat-intel-tooltip", tooltipClassName)}
            >
              {items?.map((item, index) => (
                <div key={renderKey + index}>
                  {itemMap ? itemMap(item) : item}
                </div>
              ))}
            </Tooltip>
          }
          placement={placement}
        >
          <span
            className={clsx(
              "network-threat-intel-dots-expand",
              expandDotsClassName
            )}
          >
            ...
          </span>
        </OverlayTrigger>
      </RenderWhen>
    </div>
  );
};
export default ExpandableOverlay;
